const navigationOptions = {
  admin: [
    {
      name: 'Digital First',
      route: '/admin/digitalFirst'
    },
    {
      name: 'Users',
      route: '/admin/users'
    },
    {
      name: 'Localization',
      route: '/admin/translations'
    },
    {
      name: 'Configuration',
      route: '/admin/config'
    },
    {
      name: 'Audit Logs',
      route: '/admin/auditLogs'
    },
    {
      name: 'Workers',
      route: '/admin/workers'
    },
    {
      name: 'Dashboard',
      route: '/admin/dashboard'
    }
  ]
}

export default navigationOptions
